import { C, P0, S, abs, fillAt } from '../../geometry';

export const balloon = {
  name: 'Balloon',
  colors: ['#D6409F', '#161616'],
  draw(m, t) {
    let rx = 24,
      ry = 28,
      bob = 2 * S(t * 1.3),
      sway = 3 * S(t * 1.1),
      wv = 2,
      sp = 1.6,
      pose = P0();
    if (m === 'happy') {
      bob = -4 * abs(S(t * 6));
      wv = 4;
      sp = 9;
    }
    // Thinking: drifts side to side while the string ripples.
    if (m === 'thinking') {
      sway = 10 * S(t * 1.2);
      wv = 3.5;
      sp = 4;
    }
    if (m === 'talking') {
      rx = 24 + 2 * S(t * 10);
      ry = 28 - 2 * S(t * 10);
    }
    if (m === 'surprised') {
      rx = 28;
      ry = 32;
      bob = -3;
    }
    if (m === 'paused') {
      rx = 21;
      ry = 24;
      bob = 6;
      wv = 0.6;
      sp = 0.6;
      pose.rot = 8;
    }
    const cy = 40 + bob,
      cx = 50 + sway * 0.4;
    const body = [...Array(14)].map((_, k) => {
      const a = (k / 13) * 2 * Math.PI - Math.PI / 2;
      return [cx + rx * C(a) * (1 - 0.12 * S(a)), cy + ry * S(a)];
    });
    const knotY = cy + ry;
    const string = [0, 1, 2, 3, 4].map((j) => [
      cx + (j ? wv * S(t * sp - j * 1.2) : 0) - sway * 0.1 * j,
      knotY + 4 + j * 6,
    ]);
    return {
      strokes: [
        { c: 'a', pts: body, n: 24 },
        {
          c: 'a',
          pts: [
            [cx - 3, knotY + 4],
            [cx, knotY],
            [cx + 3, knotY + 4],
          ],
          sharp: true,
        },
        { c: 'b', pts: string },
      ],
      eyes: { x: cx, y: cy },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0, 1),
};
